export { default } from './container'



// WEBPACK FOOTER //
// ./src/pages/widgets/form/media-upload/index.js